import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import './styles/reset.scss';
import './styles/main.scss';
import './plugins/element';
import './plugins/moment';
import './styles/ql-editor.scss';
import cos from 'cos-js-sdk-v5';

Vue.config.productionTip = false;
Vue.prototype.COSV5 = cos;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
